import { useSelector } from 'react-redux';
import pushRoute from '@utils/pushRoute';
import { segment } from '@actions/analytics';
import { evtNameCategoryMap } from '@constants/index';
import { CHECKOUT_STARTED } from '@constants/segment';
import segmentStorage from '@events/segmentStorage';
import useCheckoutEventProps from '@hooks/useCheckoutEventProps';

const useNotEnoughCredits = ({ goalUID, goalSlug }) => {
  const getMoreCreditsUrl = useSelector(
    ({ combats }) => combats.staticData?.[goalUID]?.getMoreCreditsUrl || ''
  );
  const eventProps = useCheckoutEventProps(goalUID);

  const goToSubscriptionPage = () => {
    segment.track(
      CHECKOUT_STARTED,
      {
        ...eventProps,
        last_primary_source: segmentStorage.getItem('lps')
      },
      evtNameCategoryMap.BOTH
    );
    pushRoute(
      '/goal/[goalSlug]/[goalUID]/subscribe',
      `/goal/${goalSlug}/${goalUID}/subscribe`,
      {},
      'combat'
    );
  };

  const openArticle = () => {
    window.open(getMoreCreditsUrl, '_blank');
  };

  return { goToSubscriptionPage, openArticle };
};

export default useNotEnoughCredits;
